<div class="input-container" [class.red]="invalid">
  <label [for]="id" [class.red]="invalid" [innerHtml]="textLabelName | translate"></label>

  <p *ngIf="explanation">{{ explanation | translate }}</p>

  <div class="date-container">
    <div class="part-container day focus-rect" [class.red]="invalid">
      <select [id]="id" [value]="selectedDay" (input)="onDayChange($event)" (change)="onDayChange($event)" (blur)="onTouch()">
        <option *ngFor="let day of days" [ngValue]="day" [selected]="this.selectedDay === day">{{day | number: '2.0'}}</option>
      </select>
    </div>
    <div class="part-container month focus-rect" [class.red]="invalid">
      <select [value]="selectedMonth" (input)="onMonthChange($event)" (change)="onMonthChange($event)" (blur)="onTouch()" [(ngModel)]="selectedMonth">
        <option *ngFor="let month of months" [ngValue]="month" [selected]="this.selectedMonth === month">{{month | number: '2.0'}}</option>
      </select>
    </div>
    <div class="part-container year focus-rect" [class.red]="invalid">
      <select [value]="selectedYear" (input)="onYearChange($event)" (change)="onYearChange($event)" (blur)="onTouch()">
        <option *ngFor="let year of years" [ngValue]="year" [selected]="this.selectedYear === year">{{year}}</option>
      </select>
    </div>
  </div>
</div>
<div *ngIf="invalid" class="errmsg">{{errormessage | translate }}</div>
